exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".board{position:relative;width:320px;margin:auto}.board canvas{box-shadow:6px 6px 6px 0 #5a5454}.controls{margin-bottom:25px;display:-ms-flexbox;display:flex;height:30px}.controls div{width:50px;height:30px;margin:auto;border:2px solid #000;border-radius:10px}.control-red{background-color:red}.control-yellow{background-color:#ff0}.control-blue{background-color:#55f}.control-green{background-color:green}.status{margin-top:20px;text-align:center}@media (min-width:700px){.play-mode .board{width:640px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/board.scss
// module id = 298
// module chunks = 0